/**
 * Copyright © Veeam Software Group GmbH.
 */

import { XmlFileParams } from '../../../enums';

export type TagAttrValue = string | null;

export interface ConfigEntry {
    name: TagAttrValue;
    value: TagAttrValue;
    isHidden: boolean;
}

export const getPropertyTags = (xml: XMLDocument): Element[] => Array.from(xml.getElementsByTagName(XmlFileParams.PropertyTag));

export const isHiddenTag = (xmlTag: Element): boolean => (
    (xmlTag.getAttribute(XmlFileParams.HiddenAttr) as TagAttrValue) === XmlFileParams.AcceptValue
);

export const getXmlEntries = (xml: XMLDocument): ConfigEntry[] => (
    getPropertyTags(xml)
        .map(xmlTag => ({
            name: xmlTag.getAttribute(XmlFileParams.NameAttr),
            value: xmlTag.getAttribute(XmlFileParams.ValueAttr),
            isHidden: isHiddenTag(xmlTag),
        }))
);
